import { create } from 'zustand';

/**
 * Toast deposu. Bilesenden AYRI dosyada: hem HMR sinirini korur hem de React
 * disindaki koddan (axios kesicileri, thunk'lar) cagrilabilir olmasi gerekir.
 *
 * Metinler CEVRILMIS gelir — depo i18n bilmez. Cagri yeri t('...') ile verir;
 * boylece anahtar testi (src/i18n/__tests__/keys.test.ts) cagri yerinde gorur.
 */
export type ToastTone = 'info' | 'success' | 'danger' | 'warning';

/**
 * Bildirimin TEK eylemi (2026-10-02, kazanma bildirimi: "Tekliflerim'e git"). Tiklaninca
 * `onClick` calisir ve bildirim kapanir. Etiket de cevrilmis gelir.
 */
export type ToastAction = {
  label: string;
  onClick: () => void;
};

export type Toast = {
  id: string;
  message: string;
  tone: ToastTone;
  /** ms. 0 verilirse kendiliginden kapanmaz (kullanicinin kapatmasi beklenir). */
  duration: number;
  action?: ToastAction;
};

export type ToastInput = {
  message: string;
  tone?: ToastTone;
  duration?: number;
  action?: ToastAction;
};

type ToastState = {
  toasts: Toast[];
  push: (toast: ToastInput) => string;
  dismiss: (id: string) => void;
  clear: () => void;
};

let counter = 0;
const nextId = (): string => {
  counter += 1;
  return `toast-${String(counter)}`;
};

export const useToastStore = create<ToastState>()((set) => ({
  toasts: [],

  push: ({ message, tone = 'info', duration = 4000, action }) => {
    const id = nextId();
    // `exactOptionalPropertyTypes`: eylem yoksa alan HIC olmamali.
    const item: Toast = { id, message, tone, duration, ...(action ? { action } : {}) };
    set((state) => ({ toasts: [...state.toasts, item] }));
    return id;
  },

  dismiss: (id) => {
    set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) }));
  },

  clear: () => {
    set({ toasts: [] });
  },
}));

/** React disindan kisa yol: toast({ message: t('errors.generic'), tone: 'danger' }). */
export const toast = (input: ToastInput): string => useToastStore.getState().push(input);
